import { useCallback, useState } from 'react';
import { useChainId } from 'src/hooks/chain';
import { useChangesSnackbar } from 'src/hooks/snackbar/useChangesSnackbar';
import { components } from 'src/infrastructure/rest-api/generated';
import { buildApiUrl, useApiMutation } from 'src/infrastructure/rest-api/useApi';

type DeleteChainFurnitureZoneInput = components['schemas']['DeleteChainFurnitureZoneInput'];

export const useChainFurnitureZoneDeleteChanges = () => {
    const chainId = useChainId();
    const showSnackbar = useChangesSnackbar();
    const [isUpdating, setIsUpdating] = useState(false);

    const [deleteFurnitureZone] = useApiMutation('/api/inventorymanagement/chains/{chainId}/furniturezones', 'delete', {
        update: (_data, variables, queryClient) => {
            queryClient.invalidateQueries({
                queryKey: [buildApiUrl('/api/inventorymanagement/chains/{chainId}/furniturezones', variables.path)],
            });
        },
    });

    const deleteChanges = useCallback(
        async (input: DeleteChainFurnitureZoneInput) => {
            if (!input.id) return;
            setIsUpdating(true);

            try {
                const response = await deleteFurnitureZone({ path: { chainId }, body: input });
                showSnackbar();
                return response;
            } catch (err) {
                showSnackbar(err);
            } finally {
                setIsUpdating(false);
            }
        },
        [chainId, deleteFurnitureZone, showSnackbar]
    );

    return [deleteChanges, { loading: isUpdating }] as const;
};
